import { EventRetryManager } from "../../../core/internal/event/EventRetryManager"
import { EventDto } from "../../../core/internal/event/dto"
import { EventRepository } from "../../../core/internal/event/EventRepository"
import { EventTransport } from "../../../core/internal/event/EventTransport"

export class BrowserEventRetryManager implements EventRetryManager {
  constructor(private readonly repository: EventRepository<EventDto>, private readonly transport: EventTransport) {}

  add(events: EventDto[]): Promise<void> {
    return this.repository.add(events)
  }

  delete(events: EventDto[]): Promise<void> {
    return this.repository.delete(events)
  }

  async flush(): Promise<void> {
    const events = await this.repository.read()
    if (events.length === 0) {
      return
    }
    const response = await this.transport.send(events)
    if (response.isSuccessful() || response.isClientError()) {
      await this.delete(events)
    }
  }
}
